import React, {useState, useEffect, useContext, useRef} from "react";
import {store} from '../../context/store';
import {functions} from "../../constants/common-functions";
import {colorFunctions} from "../../constants/colors";
import {useHistory} from 'react-router-dom';
import backgroundImage from "../../../images/nationwidebackground.png";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import {GREY_BACKGROUND} from "../../constants/general-constants";
import {PURPLE} from "../../constants/general-constants";
import UtilisationKpi from "../utilisation/components/UtilisationKpi";
import UtilisationChartLine from "../utilisation/components/UtilisationChartLine";
import UtilisationChartBar from "../utilisation/components/UtilisationChartBar";
import UtilisationChartBarBreakdown from "../utilisation/components/UtilisationChartBarBreakdown";
import UtilisationOutliers from "../utilisation/components/UtilisationOutliers";

export default function Utilisation(){
	
	const globalState = useContext(store);
	const {dispatch} = globalState;
	const history = useHistory();

	useEffect(() => {
		
	}, []);
  
  const thisContainer = {
  	display:"flex",
  	position:"fixed",
  	flexDirection:"column",
  	width:"100%",
  	height:"100vh",
  	left:"0px",
  	top:"0px",
  	//backgroundColor:GREY_BACKGROUND
  };
  
  const mainContainer = {
  	display:"flex",
  	position:"fixed",
  	top:"60px",
  	left:"60px",
  	bottom:"0px",
  	right:"0px",
  	flexDirection:"column",
  	overflow:"auto"
  };
  
  const remainingContent = {
  	display:"flex",
  	width:"100%"
  };
  
  const leftContent = {
  	display:"flex",
  	width:"870px",
  	flexDirection:"column"
  };
  
  const rightContent = {
  	display:"flex",
  	width:"calc(100% - 870px)",
  	flexDirection:"column"
  };
	
	return (
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>	
				<div style={mainContainer}>
					<UtilisationKpi/>
					<div style={remainingContent}>
						<div style={leftContent}>
							<UtilisationChartLine/>		
							<UtilisationChartBar/>				
						</div>
						<div style={rightContent}>
							<UtilisationChartBarBreakdown/>
							<UtilisationOutliers/>
						</div>
					</div>
				</div>
			</div>
	);
}